import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";
import { getRCSByCarrier } from "../api/RCSDashboardApi";

export const useRCSByCarrier = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useQuery({
    queryKey: ["RCSDashboardCarrier"],
    queryFn: async () => {
      return await getRCSByCarrier({ token: user.token });
    },
    initialData: [],
    refetchOnWindowFocus: false,
  });
};
